import makeStyles from '@material-ui/core/styles/makeStyles';
import ContactSupportIcon from '@material-ui/icons/ContactSupport';
import Box from '@material-ui/core/Box';
import Link from '@material-ui/core/Link';
import MobileStepper from '@material-ui/core/MobileStepper';
import React, { useCallback, useLayoutEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { TypistSpeedControl } from '../Typist';
import {
  Slide1,
  Slide2,
  Slide3,
  Slide4,
  Slide5,
  toWelcome4Path,
} from './Slides';

const useStyles = makeStyles((theme) => ({
  speedControlContainer: {
    position: 'fixed',
    bottom: 0,
    right: 0,
    left: 0,
    paddingRight: theme.spacing(2),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(1),
    background: `linear-gradient(rgba(255, 255, 255, 0.01) 0%, ${theme.palette.background.default} 20%)`,
  },
  speedControl: {
    '& label': {
      transform: 'translate(0, 50%) scale(0.75)',
      transformOrigin: 'bottom right',
      bottom: '55%',
      right: '110%',
      top: 'auto',
      left: 'auto',
      width: '8.5rem',
    },
    '& .MuiInput-formControl': {
      marginTop: 0,
    },
  },
  supportLink: {
    '& > svg': {
      verticalAlign: 'middle',
    },
    '& span': {
      [theme.breakpoints.down('xs')]: {
        display: 'none',
      },
    },
  },
  stepIndicator: {
    justifyContent: 'center',
    marginTop: theme.spacing(2),
  },
}));

const slides = [
  Slide1,
  Slide2,
  Slide3,
  Slide4,
  Slide5,
];

function welcomePagePath(page: string) {
  return toWelcome4Path({ page });
}

export default function Welcome() {
  const classes = useStyles();
  const { page } = useParams<{ page: string }>();
  const currentPage = Number(page);
  const history = useHistory();
  useLayoutEffect(
    () => {
      if (!currentPage) history.replace(welcomePagePath('1'));
    },
    [history, currentPage],
  );
  const handleSlideFinish = useCallback(() => {
    if (currentPage === slides.length) {
      return;
    }
    history.push(welcomePagePath(String(currentPage + 1)));
  }, [currentPage, history]);
  const slideComponents = slides.map((Slide, index) => (index === currentPage - 1
    ? <Slide key={Slide.name} onNext={handleSlideFinish} /> : null));
  return (
    <Box flex={1} flexDirection="column" display="flex" paddingBottom={7}>
      {/* eslint-disable-next-line react/no-array-index-key */}
      <MobileStepper
        variant="dots"
        steps={slides.length}
        position="static"
        activeStep={currentPage - 1}
        className={classes.stepIndicator}
        nextButton={null}
        backButton={null}
      />
      {slideComponents}
      <Box className={classes.speedControlContainer}>
        <Link href="mailto:engineers@matildaexp.com" className={classes.supportLink}>
          <ContactSupportIcon />
          <span>Questions or comments?</span>
        </Link>
        <TypistSpeedControl className={classes.speedControl} />
      </Box>
    </Box>
  );
}
